// import Cartoes from './index.vue'
import Permissions from "../../models/Permissions";

const Cartoes = () => import("./index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Cartões",
  icon: "fa fa-credit-card",
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/cartoes",
    name: "Cartões",
    component: Cartoes,
    meta,
  },
];
